export default {
  seat: {
    parenthesis: '({{text}})',
    header: {
      station: 'Please enter your purchase information.',
      seat: 'Please select the seat.',
      start: 'departure at {{time}}',
      confirm: 'Confirmation',
      seatConfirm: 'Seat Confirmation',
      reserveConfirm: 'Booking Details Confirmation',
      changeConfirm: 'Reservation Change Confirmation',
      bookingConfirm:
        '* The seat will only be officially reserved after payment and booking are completed.'
    },
    button: {
      back: 'Back',
      prev: 'Previous',
      next: 'Next',
      change: 'Change'
    },
    confirmCommon: {
      noticeTitle: 'Seat confirmation',
      notice1:
        '※The seats will be officially secured only after the reservation or change procedure is completed.',
      notice2: 'The seats are not yet secured.',
      outbound: 'Outbound',
      inbound: 'Inbound',
      seatLine: 'Car {{carNo}}-{{seatNo}}',
      departureStation: 'Departure: {{station}}',
      arrivalStation: 'Arrival: {{station}}'
    },
    confirmChange: {
      instruction: 'If there are no issues, please press "Change".',
      contentLabel: 'Change details',
      before: 'Before',
      after: 'After',
      noChange: 'No change'
    },
    confirmReserve: {
      contentLabel: 'Booking details'
    },
    selectSeatType: {
      title: 'Seat selection method',
      auto: 'Auto assignment',
      manual: 'Manual selection'
    },
    station: {
      date: 'Date',
      startStation: 'Departure station',
      endStation: 'Arrival station',
      selectTip: 'Please select the {{name}}'
    },
    train: {
      header: 'Please select the train.',
      emptySeat: 'Empty seat',
      wheelchairAvailable: 'Wheelchair space available',
      wheelchairUnavailable: 'Wheelchair space unavailable',
      noTrains:
        'There are no trains available for purchase. Please check the train operation status.',
      trainLabel: '{{trainName}} {{trainServiceNo}}'
    },
    carriage: {
      carriageCar: 'Car No.{{carNo}}',
      directionUpTitle: '↑ Toward Unazuki',
      directionDownTitle: '↑ Toward Keyakidaira',
      conductor: 'Conductor Seat'
    },
    wheelchairConfirm: {
      title: 'You have selected a wheelchair-only space.',
      content: 'This space is reserved exclusively for wheelchair users.',
      notice1: 'Up to one attendant per two wheelchair spaces may accompany.',
      confirmText: 'Would you like to continue with this selection?',
      cancel: 'Cancel',
      confirm: 'Yes'
    }
  },
  error: {
    invalidParams:
      'The specified conditions are invalid. Please start over from the beginning',
    invalidDate: 'This date cannot be selected.',
    lineIdInvalid:
      'No line has been selected. Please start over from the beginning',
    productIdInvalid:
      'The selected seat type is invalid. Please start over from the beginning',
    forbidden:
      'This operation is not allowed. Please start over from the beginning',
    seatChangeCountExceeded: 'The number of seat changes is limited to 2 times',
    notFound:
      'The page you are looking for cannot be found. Please start over from the beginning',
    notFoundTitle: 'The page you are looking for could not be found.',
    notFoundDescription: 'Please check that the URL is correct.',
    systemError: 'A system error has occurred. Please try again later'
  }
};
